<template>
  <div
    class="m-pc-partner new top-nav"
    id="partner"
    v-if="extras.groupPartnerDisplay.display == 1 && columns.length > 0"
    :style="{
      background:
        extras.partnerBg.colorOrBg == 'color'
          ? extras.partnerBg.color
          : 'url(' + extras.partnerBg.src + ')',
    }"
  >
    <Title
      v-if="extras.partnerTitle.display == 1"
      :title="extras.partnerTitle.mainTitle || title"
      :en="extras.partnerTitle.subTitle || 'MEDIA'"
      :extras="extras"
    />
    <div class="g-partner-content u-w1200">
      <div class="g-parter-details">
        <div style="position: relative; overflow: hidden" ref="partnerTab">
          <div
            class="m-tab-list-new"
            v-if="
              columns.length > 1 || (columns.length == 1 && columns[0].id != 0)
            "
            :class="'tab-length' + columns.length"
            :style="{
              width: columns.length < 5 ? 'auto' : '',
              display: columns.length < 5 ? 'flex' : 'inline-block',
            }"
          >
            <div
              class="tab-new u-mr30"
              v-for="(item, index) in columns"
              :key="index"
              :class="{
                active: index == currentId,
                'cursor-default': isSetting == 1,
              }"
              @click="columnClick(item, index)"
            >
              {{ item.name }}
              <div data-v-2a8f24dd="" class="underline"></div>
            </div>
          </div>
        </div>

        <div class="g-par-box" id="partners">
          <div class="g-partner-list-new">
            <div
              class="item"
              v-for="(item, i) in articles"
              :key="i"
              @click="didClickPartner(item)"
              :style="{
                cursor:
                  extras.partnerStyle.style == 'none' ? 'default' : 'pointer',
              }"
            >
              <img
                :src="
                  item.coverImageRealPath
                    ? item.coverImageRealPath
                    : require('@/assets/images/defPartner.png')
                "
              />
            </div>
          </div>
          <ol class="m-btn-list parBtns"></ol>
          <div class="m-nodata-body" v-if="articles && articles.length == 0">
            <img src="@/assets/images/nodata.png" />
            <div class="m-nodata">{{ $t("暂无数据") }}</div>
          </div>
        </div>
      </div>
    </div>
    <!--合作伙伴弹窗-->
    <div class="g-popup new" v-if="popShow">
      <div class="popup-block">
        <!--        <div class="block-close" @click="didClickCloseImg">-->
        <!--          <img class="close-img" />-->
        <!--        </div>-->

        <span
          class="icon icontemp stemp-close"
          @click="didClickCloseImg"
        ></span>
        <div class="block-content">
          <img
            :src="
              popData.coverImageRealPath
                ? popData.coverImageRealPath
                : require('@/assets/images/defaultPar.jpg')
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from "./Title.vue";
import { URLS } from "fire-wind-water";
import IScroll from "iscroll";
import { tMixin } from "../../utils/i18n-t";

export default {
  components: {
    Title,
  },
  mixins: [tMixin],
  props: {
    partnerInfo: [],
    extras: Object,
  },
  data() {
    return {
      title: "合作伙伴",
      isSetting: 0,
      currentId: 0,
      columns: [],
      articles: [],
      isShowMore: false,
      popShow: false,
      popData: null,
    };
  },
  created() {
    if (URLS.getURL("isSetting") == 1) {
      this.isSetting = 1;
    }
  },
  mounted() {
    console.log("pc-partner", this.partnerInfo);
    //this.initColumns();

    let tempColumns = this.getColumns.articleInitColumns(
      this.partnerInfo.column,
      this.partnerInfo.article,
      "合作伙伴",
      true
    );
    this.columns = tempColumns;
    ///显示tab再初始化滚动效果
    if (
      this.columns.length > 1 ||
      (this.columns.length == 1 && this.columns[0].id != 0)
    ) {
      this.$nextTick(() => {
        new IScroll(this.$refs.partnerTab, {
          mouseWheel: false, // 鼠标滚轮控制
          scrollbars: false, //滚动条的显示
          scrollX: true,
          scrollY: false,
        });
      });
    }

    this.articles = this.columns.length > 0 ? this.columns[0].article : [];
  },
  methods: {
    initColumns() {
      let tempArticles = this.partnerInfo.article;
      let tempColumns = this.partnerInfo.column;
      // if (tempColumns.length == 0) {
      //   return;
      // }
      const columns = [
        {
          id: 0,
          name: "合作伙伴",
          article: tempArticles,
        },
      ];
      for (let i in tempArticles) {
        let c = tempArticles[i].desc ? tempArticles[i].desc.substr(0, 130) : "";
        tempArticles[i].desc = c;
      }
      for (let i in tempColumns) {
        columns.push(tempColumns[i]);
      }
      this.columns = columns;
      // this.currentId = this.columns[0].id;
      this.articles = this.columns[0].article;
    },
    columnClick(item, idx) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }

      this.currentId = idx;
      this.articles = item.article;
    },
    showMoreArticle() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.isShowMore = !this.isShowMore;
    },
    didClickPartner(item) {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      if (this.extras.partnerStyle.style == "none") {
        return;
      }
      console.log(item);
      this.popShow = true;
      this.popData = item;
    },
    didClickCloseImg() {
      if (URLS.getURL("isSetting") == 1) {
        return;
      }
      this.popShow = false;
      this.popData = null;
    },
  },
};
</script>
<style scoped></style>
